import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { AsYouType } from 'libphonenumber-js'

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

/**
 * Formats a phone number for display
 * @param {string} phoneNumber - Phone number (can be formatted or just digits)
 * @returns {string} - Formatted phone number (e.g., "(555) 123-4567")
 */
export function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    
    // Extract only digits
    const digits = phoneNumber.replace(/\D/g, '');
    
    if (!digits || digits.length < 10) {
        // If not enough digits, return as-is
        return phoneNumber;
    }
    
    // Format using AsYouType (defaults to US format)
    const formatter = new AsYouType('US');
    const formatted = formatter.input(digits);
    
    // Return formatted version, or original if formatting didn't work
    return formatted || phoneNumber;
}

